// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","title":"styles_title__nyC0_","modal":"styles_modal__1dxYS","button":"styles_button__bz0Xe"};